import React, { useState } from "react";
import TicketList from "./TicketList";
import CreateTicketForm from "./CreateTicketForm";

const TicketPage = () => {
  const [activeTab, setActiveTab] = useState("list");

  return (
    <div className="container mt-4">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            My Tickets
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "create" ? "active" : ""}`}
            onClick={() => setActiveTab("create")}
          >
            Create Ticket
          </button>
        </li>
      </ul>

      <div className="tab-content mt-3">
        {activeTab === "list" && <TicketList />}
        {activeTab === "create" && (
          <CreateTicketForm onTicketCreated={() => setActiveTab("list")} />
        )}
      </div>
    </div>
  );
};

export default TicketPage;
